(function () {
  'use strict';

  /* Mobile menu */
  var menu = document.querySelector('.menu-button');
  var nav = document.querySelector('#navigation');
  function closeMenu() {
    if (!menu || !nav) return;
    nav.classList.remove('open');
    menu.setAttribute('aria-expanded', 'false');
  }
  if (menu && nav) {
    menu.addEventListener('click', function () {
      var open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('open', open);
    });
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* Salon trial dialog */
  var dialog = document.querySelector('#trial-dialog');
  if (dialog && typeof dialog.showModal === 'function') {
    document.querySelectorAll('[data-trial-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.showModal(); });
    });
    var close = dialog.querySelector('.close');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) {
        var r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      }
    });
    if (dialog.querySelector('[data-open]')) dialog.showModal();
  }

  /* Collection sort */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
